import { TriangleAlert } from "lucide-react";
import { Color } from "utils/theme";
import { Button } from "components/ui/button";
import { Spinner } from "components/ui/spinner";

interface ErrorStateProps {
  title: string;
  description: string;
  detail?: string;
  retryLabel?: string;
  retrying?: boolean;
  onRetry?: () => void;
}

export const ErrorState = ({
  title,
  description,
  detail,
  retryLabel,
  retrying,
  onRetry,
}: ErrorStateProps) => (
  <div className="w-full flex-1 flex items-center justify-center">
    <div className="flex flex-col items-center text-center gap-3 max-w-md p-5">
      <div
        className="rounded-full p-4"
        style={{ backgroundColor: Color.Primary[700] }}
      >
        <TriangleAlert className="size-8" style={{ color: Color.Amber[400] }} />
      </div>
      <h3
        className="text-lg font-semibold"
        style={{ color: Color.Primary[200] }}
      >
        {title}
      </h3>
      <p style={{ color: Color.Primary[400] }}>{description}</p>
      {detail ? (
        <p className="text-sm" style={{ color: Color.Primary[500] }}>
          {detail}
        </p>
      ) : null}
      {onRetry ? (
        <Button
          variant="secondary"
          className="mt-2 w-full sm:w-[160px]"
          onClick={onRetry}
          disabled={retrying}
        >
          {retrying ? <Spinner className="size-5 mr-3" /> : null}
          {retryLabel}
        </Button>
      ) : null}
    </div>
  </div>
);
